import React = require('react');
import { Messages } from '../../../../../gen-src/Localize';
import { Style } from '../style/StyleFunctions';
import { SiteUrlsContext } from '../urls/SiteUrlsContext';

/** This matches the HiddenUserStyle in VizPortalClient */
export const ProjectLocationPlaceholderStyle: React.CSSProperties & Style = {
  color: '#BFBFBF',
  fontWeight: 'inherit',
  fontStyle: 'italic',
};

export function DefaultNoneProjectLocation(): JSX.Element {
  return <span style={ProjectLocationPlaceholderStyle}>{Messages.None()}</span>;
}

export function NotApplicableProjectLocation(): JSX.Element {
  return <span style={ProjectLocationPlaceholderStyle}>{Messages.NotApplicable()}</span>;
}

export function DefaultHiddenProjectLocation(): JSX.Element {
  return (
    <span style={ProjectLocationPlaceholderStyle}>
      {Messages.PermissionsRequired()}
    </span>
  );
}

export type ProjectLocationLinkProps = {
  /** The id of the project */
  readonly id: string;

  /** The URL of that project's place page */
  readonly url: string;

  /** The path of that project's place page (for use when rendering React Router links) */
  readonly pathname: string;
};

export type ProjectLocationLinkDisplayComponentProps = {
  /**
   * Null means that there is no project location so render the none location element;
   * The story Story 1338824: [DBs in Projects][UI] Integrate location column cell formatters with webclient api responses
   * deals with adding obfuscation handling for the hidden location element case.
   */
  readonly location: string | null;

  /**
   * Null means that there is no project location so render the none location element;
   * The story Story 1338824: [DBs in Projects][UI] Integrate location column cell formatters with webclient api responses
   * deals with adding obfuscation handling for the hidden location element case.
   */
  readonly locationId: string | null;

  /**
   * Null means that there is no project location so render the none location element;
   * True means that the location is Not applicable
   */
  readonly isEmbedded: boolean | null;

  /**
   * Show this element when the project location is supposed to be hidden. If undefined, a default element will be used.
   */
  readonly hiddenLocationElement: JSX.Element | undefined;

  /**
   * Show this element when the project location is nonexistent. If not provided, a default element will be used.
   */
  readonly noneLocationElement: JSX.Element | undefined;

  /**
   * Show this element when the project location is Not applicable. If undefined, a default element will be used.
   */
  readonly notApplicableLocationElement: JSX.Element | undefined;

  readonly linkComponent: React.ComponentType<ProjectLocationLinkProps>;
};

export function ProjectLocationLinkDisplayComponent(
  props: ProjectLocationLinkDisplayComponentProps
): JSX.Element {
  const urls = React.useContext(SiteUrlsContext);

  if (props.isEmbedded) {
    return props.notApplicableLocationElement || <NotApplicableProjectLocation/>;
  }
  else if (!props.location || !props.locationId) {
    return props.noneLocationElement || <DefaultNoneProjectLocation />;
  }

  // TODO: Add obfuscation case
  // Story 1338824: [DBs in Projects][UI] Integrate location column cell formatters with webclient api responses
  else {
    const url = urls.projectUrl(props.locationId);
    const path = urls.projectPath(props.location);
    return (
      <props.linkComponent url={url} pathname={path} id={props.locationId} />
    );
  }
}
